"use strict";

export var UserScriptConstants = {
  FORM_EDIT_CUSTOM_ACTION: 'FORM_EDIT_CUSTOM_ACTION',
  TABLE_CUSTOM_ACTION: 'TABLE_CUSTOM_ACTION'
};